import seckill from './seckill'
const haierseckill = {
    install: function(Vue){
        //第一个参数要对应数据的code
        Vue.component('haier-h5-seckill',seckill)
    }
}
// 导出组件
export default haierseckill